<template>

    <nav class="navbar navbar-default navbar-fixed-top navbar-inverse" v-if="authenticated">
        <div class="navbar-header">
            <button type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#bs-mobile-collapse-menu" aria-expanded="false">
                <span class="sr-only">Toggle navigation</span>
                <span class="icon-bar"></span>
                <span class="icon-bar"></span>
                <span class="icon-bar"></span>
            </button>
            <router-link to="/" class="navbar-brand"><img class="logo" alt="Lewis Rice" src="../assets/images/lewis-rice-logo-white.svg"></router-link>
        </div>
        <div class="collapse navbar-collapse" id="bs-mobile-collapse-menu" v-if="authenticated">
            <ul class="nav navbar-nav">
                <li>
                    <router-link to="/" data-toggle="collapse" data-target=".navbar-collapse">Home</router-link>
                </li>
                <li>
                    <router-link to="/logout" data-toggle="collapse" data-target=".navbar-collapse">Logout</router-link>
                </li>
                <li>
                    <router-link to="/user-settings" data-toggle="collapse" data-target=".navbar-collapse">My Settings</router-link>
                </li>
            </ul>
        </div>
    </nav>

</template>



<script>

    export default {

        name: 'navbar',

        props: ['authenticated']
        
    }

</script>



<style lang="scss" scoped>

    @import "../variables";

    .logo {
        height: 1em;
    }

    .navbar-inverse {
        background-color: $brand-blue-dark;
    }

    .navbar-inverse .navbar-toggle {
        border-color: transparent;

        &:focus {
            background-color: rgba(255, 255, 255, 0.1);
        }
    }

    #bs-mobile-collapse-menu ul.nav li {
        font-weight: 400;
        font-size: 1.5em;
    }

</style>



// WEBPACK FOOTER //
// Navbar.vue?05126a89